import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default function index() {

  const canvas = document.getElementById('salesChartNEW')
  if (!canvas) return

  Chart.register(ChartDataLabels)

  new Chart(canvas.getContext('2d'), {
    type: 'bar',
    data: {
      labels: [
        ['第1期', '20/10-21/03'],
        ['第2期', '21/04-22/03'],
        ['第3期', '22/04-23/03'],
        ['第4期', '23/04-24/03'],
        ['第5期', '24/04-25/03'],
        ['第6期', '(目標)']
      ],
      datasets: [{
        data: [0.18, 10.62, 14.93, 19.32, 28.27, 31.00],
        backgroundColor: [
          '#029b27',
          '#029b27',
          '#029b27',
          '#029b27',
          '#029b27',
          '#f85515'
        ],
        borderRadius: 2,
        barPercentage: 0.4
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        title: {
          display: true,
          text: '（億円）',
          align: 'start',
          color: '#17023a',
          font: { size: 12, weight: '700' },
        },
        datalabels: {
          display: () => window.innerWidth > 768,
          anchor: 'end',
          align: 'top',
          color: '#17023a',
          font: { size: 13, weight: 'bold' },
          formatter: v => v.toFixed(2) + ' 億円'
        }
      },
      scales: {
        x: { 
          ticks: { font: { size: window.innerWidth < 640 ? 10 : 12, weight: '700' }, color: '#17023a' }, 
          grid: { display: false } 
        },
        y: { 
          beginAtZero: true, 
          grid: { color: 'rgba(0,0,0,0.05)' },
          ticks: { color: '#17023a', font: { weight: '700' } }
        }
      }
    }
  })
}
